'use strict';

var cache = {};

const collapse = {
    initCollapseCache: function () {
        cache.$collapseContainer = $('.js-bbw-collapse');
        cache.$collapsePanels = cache.$collapseContainer.find('.js-collapse-panel');
        cache.$collapseItem = cache.$collapseContainer.find('.js-collapse-item');
        cache.$collapseCta = $('.js-collapse-cta');
    },
    init: function () {
        this.initCollapseCache();
        this.setInitialState();
        this.initEvents();
    },
    setInitialState: function () {
        cache.$collapseContainer.find('.js-collapse-item:not(.collapse-active)').find('.js-collapse-panel').slideUp(function () {
            cache.$collapseContainer.removeClass('d-none');
        });

        cache.$collapseContainer.find('.js-collapse-item.collapse-active').find('.js-collapse-panel').slideDown(function () {
            cache.$collapseContainer.removeClass('d-none');
        });
    },
    initEvents: function () {
        cache.$collapseCta.on('click', function () {
            var $this = $(this);
            var $item = $this.closest('.js-collapse-item');
            var $panel = $item .find('.js-collapse-panel');

            $item.toggleClass('collapse-active');
            $panel.slideToggle();
        });
    }
};

module.exports = collapse;
